<template>
  <div class="h-full w-full p-20 text-center" data-test="TLoadingIndicatorBig">
    <TIcon
      name="loader"
      class="mr-2 inline h-12 w-12 animate-spin text-neutral-400"
    />
  </div>
</template>
